import { render, staticRenderFns } from "./TeamFormDialog.vue?vue&type=template&id=388baa60"
import script from "./TeamFormDialog.vue?vue&type=script&lang=js"
export * from "./TeamFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports